import React, { useState } from 'react';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import IconSearch from '../../../../assets/svg/ic-actions-search.svg';
import IconLink from '../../../../assets/svg/ic-actions-new-window.svg';
import IconImpressora from '../../../../assets/svg/print.svg';
import { openReceita } from '../../../../Libs/Docs.js';
import { confirmAlert } from 'react-confirm-alert';
import ModalEnvio from '../../../../gb-components/ModalEnvio';
import ModalComponent from '../../../../components/Modal';

const CardReceita = ({ interacao, paciente, profissional, DataCriacao, prescricao_1, prescricao_2, prescricao_3, prescricao_4, Hora, remedio_1, remedio_2, remedio_3, remedio_4, receitaId, OpenModal }) => {

  const [profNome, setProfNome] = useState('');
  const [isVisibleSend, setIsVisibleSend] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const sending = false;

  const confirmTipoImpressaoReceita = () => {

    confirmAlert({
      title: 'Tipo',
      message: 'Qual tipo de receituário deseja imprimir?',
      buttons: [
        {
          label: 'Comum',
          onClick: () => {
            openReceita(paciente.id, receitaId, "Comum");
          }
        },
        {
          label: 'Especial',
          onClick: () => {

            openReceita(paciente.id, receitaId, "Especial");

          }


        }
      ]
    });
  }

  const renderBody = () => {
    return (
      <div>
        {" "}
        {remedio_1 ? (
          <p><strong>1º Remédio:</strong> {remedio_1}</p>
        ) : null}
        {prescricao_1 ? (
          <p><strong>1ª Prescrição:</strong> {prescricao_1}</p>
        ) : null}
        {remedio_2 ? (
          <p><strong>2º Remédio:</strong> {remedio_2}</p>
        ) : null}
        {prescricao_2 ? (
          <p><strong>2ª Prescrição:</strong> {prescricao_2}</p>
        ) : null}
        {remedio_3 ? (
          <p><strong>3º Remédio:</strong> {remedio_3}</p>
        ) : null}
        {prescricao_3 ? (
          <p><strong>3ª Prescrição:</strong> {prescricao_3}</p>
        ) : null}
        {remedio_4 ? (
          <p><strong>4º Remédio:</strong> {remedio_4}</p>
        ) : null}
        {prescricao_4 ? (
          <p><strong>4ª Prescrição:</strong> {prescricao_4}</p>
        ) : null}{" "}
      </div>
    )
  }


  return (
    <>
      <div className={"gb-card mb-3"}>
        <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
          <p>{profissional ? profissional : profNome}{" "}{/* {Concluida ? (<p>{Concluida}</p>) : null} */}</p>
          <div style={{ textAlign: getLoggedInUser().username === profissional ? 'right' : null, }}>
            {DataCriacao ? (
              <span className="gb-card-header-hora">
                {" "}{DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
              </span>
            ) : null}

            <div style={{ textAlign: getLoggedInUser().username === profissional ? 'left' : 'right' }}>

              <a href="#" onClick={OpenModal}>
                <img src={IconSearch} style={{ marginLeft: 15 }} />
              </a>

              <a href="#" onClick={() => setOpenPrint(true)}>
                <img src={IconImpressora} style={{ marginLeft: 15 }} />
              </a>

              {/* {sending ? (<PreLoaderWidget ></PreLoaderWidget>) : ( */}
              <a href="#" onClick={() => setIsVisibleSend(true)}>
                <img src={IconLink} style={{ marginLeft: 15 }} />
              </a>

              {/* )} */}
            </div>
          </div>

        </div>

        <div className="gb-card-body">
          {renderBody()}
        </div>

      </div>
      <ModalComponent openModal={openPrint} closeModal={() => setOpenPrint(false)} auto>
        <div style={{ width: 400 }}>

          <h1>Tipo de receituário</h1>
          Qual tipo de receituário deseja imprimir?
          <div className="row mt-3">
            <div className="col-sm-12 col-md-6">
              <button className="btn gb-button-border full" onClick={() => openReceita(paciente.id, receitaId, "Comum")}>Comum</button>
            </div>
            <div className="col-sm-12 col-md-6">
              <button className="btn gb-button full" onClick={() => openReceita(paciente.id, receitaId, "Especial")}>Especial</button>
            </div>
          </div>
        </div>
      </ModalComponent>


      {(receitaId) ? <ModalEnvio visible={isVisibleSend}
        close={() => setIsVisibleSend(false)}
        pacienteId={paciente.id}
        card={'receita'}
        docId={receitaId}
        email={paciente.paciente.email}
        telefone={paciente.paciente.whatsapp ? paciente.paciente.whatsapp : paciente.paciente.telefones} /> : null}
    </>
  )
}

export default CardReceita;